/** A source reference is shown only when it holds real text. null, undefined, "", "-", "N/A" and similar placeholders count as empty. */
const PLACEHOLDERS = new Set(["", "-", "--", "—", "–", "n/a", "na", "none", "null", "undefined", "unknown", "tbd", "not available", "not applicable"]);

/** The trimmed text, or null when there is nothing worth showing. */
export function cleanSource(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const text = value.trim();
  return PLACEHOLDERS.has(text.toLowerCase()) ? null : text;
}

/** "Label (p. 12)" from a source_ref object, or null when it has no usable label. */
export function sourceLine(ref: { label?: unknown; page_label?: unknown } | null | undefined): string | null {
  if (!ref) return null;
  const label = cleanSource(ref.label);
  if (!label) return null;
  const page = cleanSource(ref.page_label);
  return page ? `${label} (p. ${page})` : label;
}
